export default __webpack_public_path__ + "static/media/twitter.f6e6e036.svg";